import { render, staticRenderFns } from "./CardBed.vue?vue&type=template&id=86db672a&"
import script from "./CardBed.vue?vue&type=script&lang=js&"
export * from "./CardBed.vue?vue&type=script&lang=js&"
import style0 from "./CardBed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports